// API service for client to communicate with backend
const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://backend-service-11844559410.us-central1.run.app/api";

// Generic API request function
const apiRequest = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  const config = {
    headers: {
      "Content-Type": "application/json",
    },
    ...options,
  };

  try {
    const response = await fetch(url, config);
    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "API request failed");
    }

    return data;
  } catch (error) {
    console.error("API request error:", error);
    throw error;
  }
};

// Awards API
export const awardsAPI = {
  getAll: async () => {
    return apiRequest("/awards");
  },

  getRecent: async () => {
    return apiRequest("/awards/recent");
  },

  getById: async (id) => {
    return apiRequest(`/awards/${id}`);
  },
};

// News API
export const newsAPI = {
  getAll: async () => {
    return apiRequest("/news");
  },

  getRecent: async () => {
    return apiRequest("/news/recent");
  },

  getById: async (id) => {
    return apiRequest(`/news/${id}`);
  },
};

// Gallery API
export const galleryAPI = {
  getAll: async () => {
    return apiRequest("/gallery");
  },

  getFeatured: async (limit = 12) => {
    return apiRequest(`/gallery/featured?limit=${limit}`);
  },

  getFeaturedByCategory: async (category, limit = 12) => {
    return apiRequest(
      `/gallery/featured/${encodeURIComponent(category)}?limit=${limit}`
    );
  },

  getById: async (id) => {
    return apiRequest(`/gallery/${id}`);
  },
};

// Contact API
export const contactAPI = {
  create: async (contactData) => {
    return apiRequest("/contacts", {
      method: "POST",
      body: JSON.stringify(contactData),
    });
  },
};

export default {
  awards: awardsAPI,
  news: newsAPI,
  gallery: galleryAPI,
  contact: contactAPI,
};
